"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../../components");
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _api = require("./api");
var _SuccessRegisterContent = _interopRequireDefault(require("./SuccessRegisterContent"));
var _SessionsCancelContent = _interopRequireDefault(require("./SessionsCancelContent"));
var _GroupSessionsList = _interopRequireDefault(require("./GroupSessionsList"));
var _types = require("../../../types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SessionsManagement = function SessionsManagement(_ref) {
  var group = _ref.group,
    upcomingSessions = _ref.upcomingSessions,
    rsvps = _ref.rsvps,
    onRefetchRsvps = _ref.onRefetchRsvps,
    sessionsModal = _ref.sessionsModal,
    setSessionsModal = _ref.setSessionsModal,
    _ref$onCloseSuccessMo = _ref.onCloseSuccessModal,
    onCloseSuccessModal = _ref$onCloseSuccessMo === void 0 ? _lodash.noop : _ref$onCloseSuccessMo,
    _ref$onClickSignUp = _ref.onClickSignUp,
    onClickSignUp = _ref$onClickSignUp === void 0 ? _lodash.noop : _ref$onClickSignUp,
    md = _ref.md;
  var rsvpsBySessionId = (0, _react.useMemo)(function () {
    return (0, _lodash.keyBy)(rsvps, 'groupSessionId');
  }, [rsvps]);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSessionIds = _useState2[0],
    setSelectedSessionIds = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    successModalVisible = _useState4[0],
    setSuccessModalVisible = _useState4[1];
  var _useRsvpToSessions = (0, _api.useRsvpToSessions)(),
    onCreateRsvps = _useRsvpToSessions.onCreateRsvps,
    onCancelRsvp = _useRsvpToSessions.onCancelRsvp,
    rsvpProcessing = _useRsvpToSessions.processing;
  var comingSoon = group.status === _types.GroupStatus.ComingSoon;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showCancelModal = _useState6[0],
    setShowCancelModal = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    cancelSession = _useState8[0],
    setCancelSession = _useState8[1];
  (0, _react.useEffect)(function () {
    if (rsvps) {
      setSelectedSessionIds(rsvps.map(function (session) {
        return session.groupSessionId;
      }));
    } else {
      setSelectedSessionIds([]);
    }
  }, [rsvps, sessionsModal]);
  var handleClickRegister = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(sessionIds) {
      var filtered;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!sessionIds) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return onCreateRsvps(sessionIds);
            case 3:
              if (!selectedSessionIds) {
                _context.next = 12;
                break;
              }
              if (!rsvps) {
                _context.next = 10;
                break;
              }
              filtered = (0, _lodash.filter)(selectedSessionIds, function (sessionId) {
                return !(0, _lodash.find)(rsvps, function (rsvp) {
                  return rsvp.groupSessionId === sessionId;
                });
              });
              _context.next = 8;
              return onCreateRsvps(filtered);
            case 8:
              _context.next = 12;
              break;
            case 10:
              _context.next = 12;
              return onCreateRsvps(selectedSessionIds);
            case 12:
              if (md) {
                setSessionsModal(false);
              }
              setSuccessModalVisible(true);
              onRefetchRsvps();
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleClickRegister(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCloseSuccessModal = function handleCloseSuccessModal() {
    onRefetchRsvps();
    setSuccessModalVisible(false);
    setSessionsModal(false);
    onCloseSuccessModal();
  };
  var handleCheckedSessions = function handleCheckedSessions(session) {
    setSelectedSessionIds(function (prevSelectedSessionIds) {
      if (prevSelectedSessionIds.includes(session)) {
        return (0, _lodash.filter)(prevSelectedSessionIds, function (s) {
          return s !== session;
        });
      } else {
        return [].concat(_toConsumableArray(prevSelectedSessionIds), [session]);
      }
    });
  };
  var handlePromptCancel = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(session) {
      var rsvpId;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              rsvpId = rsvpsBySessionId[session.id].id;
              if (!rsvpId) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return onCancelRsvp(rsvpId);
            case 4:
              _utils.toast.success({
                title: 'Registration canceled'
              });
            case 5:
              onRefetchRsvps();
              setShowCancelModal(false);
              setSessionsModal(true);
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function handlePromptCancel(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var closeCancelModal = function closeCancelModal() {
    setShowCancelModal(false);
    setSessionsModal(true);
  };
  var registerDisabled = (0, _react.useMemo)(function () {
    if ((0, _lodash.isEmpty)(selectedSessionIds)) {
      return true;
    }
    // We only show the button as enabled if the sessions currentrly not having rsvps are selected
    var filtered = (0, _lodash.filter)(selectedSessionIds, function (id) {
      return (0, _lodash.get)(rsvpsBySessionId[id], 'status') !== _types.RsvpStatus.Attending;
    });
    return (0, _lodash.isEmpty)(filtered);
  }, [selectedSessionIds, rsvps]);
  if (md) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: sessionsModal,
      className: "z-40",
      bodyStyle: {
        padding: '0px'
      },
      onCancel: function onCancel() {
        return setSessionsModal(false);
      }
    }, /*#__PURE__*/_react.default.createElement(_spin.default, {
      spinning: rsvpProcessing
    }, !showCancelModal && !successModalVisible && /*#__PURE__*/_react.default.createElement(_GroupSessionsList.default, {
      upcomingSessions: upcomingSessions,
      setSessionsModal: setSessionsModal,
      rsvpProcessing: rsvpProcessing,
      rsvpsBySessionId: rsvpsBySessionId,
      comingSoon: comingSoon,
      handleCheckedSessions: handleCheckedSessions,
      selectedSessionIds: selectedSessionIds,
      group: group,
      handlePromptCancel: handlePromptCancel,
      setShowCancelModal: setShowCancelModal,
      setCancelSession: setCancelSession,
      registerDisabled: registerDisabled,
      onClickSignUp: onClickSignUp,
      handleClickRegister: handleClickRegister,
      md: md
    }))), showCancelModal && /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: true,
      onClose: closeCancelModal,
      onCancel: closeCancelModal
    }, /*#__PURE__*/_react.default.createElement(_SessionsCancelContent.default, {
      group: group,
      handlePromptCancel: handlePromptCancel,
      cancelSession: cancelSession,
      closeCancelModal: closeCancelModal
    })), successModalVisible && /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: true,
      onClose: handleCloseSuccessModal,
      onCancel: handleCloseSuccessModal,
      footer: null,
      maskClosable: false
    }, /*#__PURE__*/_react.default.createElement(_SuccessRegisterContent.default, {
      close: handleCloseSuccessModal
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: rsvpProcessing,
    className: "flex h-full items-center justify-center"
  }, !showCancelModal && !successModalVisible && /*#__PURE__*/_react.default.createElement(_GroupSessionsList.default, {
    upcomingSessions: upcomingSessions,
    setSessionsModal: setSessionsModal,
    rsvpProcessing: rsvpProcessing,
    rsvpsBySessionId: rsvpsBySessionId,
    comingSoon: comingSoon,
    handleCheckedSessions: handleCheckedSessions,
    selectedSessionIds: selectedSessionIds,
    group: group,
    handlePromptCancel: handlePromptCancel,
    setShowCancelModal: setShowCancelModal,
    setCancelSession: setCancelSession,
    registerDisabled: registerDisabled,
    onClickSignUp: onClickSignUp,
    handleClickRegister: handleClickRegister,
    md: md
  }), successModalVisible && /*#__PURE__*/_react.default.createElement(_SuccessRegisterContent.default, {
    close: handleCloseSuccessModal
  }), showCancelModal && /*#__PURE__*/_react.default.createElement(_SessionsCancelContent.default, {
    group: group,
    handlePromptCancel: handlePromptCancel,
    cancelSession: cancelSession,
    closeCancelModal: closeCancelModal
  })));
};
var _default = SessionsManagement;
exports.default = _default;